import { render } from "./NewKanban.vue?vue&type=template&id=2fe77b7b"
import script from "./NewKanban.vue?vue&type=script&lang=js"
export * from "./NewKanban.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__